export default __webpack_public_path__ + "static/media/auth_bg_no_earth.0d95eb20.jpg";